import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';
import truncate from 'truncate-html';
import MicroModal from 'micromodal';
import SimpleBar from 'simplebar';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $sliderMain: this.el._$('.modal-image-gallery__slides'),
      $slides: this.el._$$('.modal-image-gallery__slide'),
      $sliderNavigation: this.el._$('.modal-image-gallery__navigation'),
      $sliderModal: this.el._$('.modal-image-gallery__modal-slider'),
      $captions: this.el._$$('.modal-image-gallery__caption')
    };

    //swipper
    this.swiperMain = null;
    this.swiperNavigation = null;
    this.swiperModal = null;
    this.loopedSlides = 6;
    this.spaceBetween = 20;
    this.loop = true;

    //truncate
    this.captionLimit = 160;

    //Modal
    this.openModalClass = 'modal-image-gallery__open-modal';
    this.openTrigger = 'data-generic-modal-open';
    this.closeTrigger = 'data-generic-modal-close';
    this.openClass = 'generic-modal--open';
    this.modalId = this.el.getAttribute('data-modal-id');

    this.init();
  } //setupDefaults

  addListeners() {
    const { $openModal } = this.dom;

    $openModal._on('click', this.openModal.bind(this));
  } //addListeners

  init() {
    this.truncateCaptions();

    this.sliderNavigation();
    this.sliderMain();
    this.sliderModal();
    this.sliderController();

    this.setOpenModals();

    this.setSimpleBars();
  } //init

  openModal(e) {
    e.preventDefault();

    if (this.modalId) {
      MicroModal.show(this.modalId, {
        openTrigger: this.openTrigger,
        closeTrigger: this.closeTrigger,
        openClass: this.openClass,
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onShow: modal => {
          $('.generic-modal__overlay').removeAttr('data-generic-modal-close');
          document.body.classList.add('show-modal');
          if (this.swiperModal) {
            setTimeout(
              () => {
                this.swiperModal.updateAutoHeight();
              },
              window.document.documentMode ? 300 : 100
            );
          }
        },
        onClose(modal) {
          document.body.classList.remove('show-modal');
        }
      });
    }
  } //openModal

  truncateCaptions() {
    const { $captions } = this.dom;

    try {
      for (const $caption of $captions) {
        let ellipsis = '';

        const moreLabel = $caption.getAttribute('data-more-label');
        if (moreLabel) {
          ellipsis = `... <a href="#" class="${this.openModalClass}">${moreLabel}</a>`;
        } else {
          ellipsis = `... <a href="#" class="${this.openModalClass}">More</a>`;
        }

        const html = $caption.innerHTML;
        const truncateHtml = truncate(html, {
          ellipsis,
          length: this.captionLimit
        });

        $caption.innerHTML = truncateHtml;
      }
    } catch (error) {
      return;
    }
  } //truncateCaptions

  sliderNavigation() {
    const { $sliderNavigation } = this.dom;
    if (!$sliderNavigation) return;

    this.swiperNavigation = new Swiper($sliderNavigation, {
      autoHeight: true,
      centeredSlides: true,
      loop: this.loop,
      loopedSlides: this.loopedSlides,
      slidesPerView: 3,
      spaceBetween: this.spaceBetween
    });
  } //sliderNavigation

  sliderMain() {
    const { $sliderMain } = this.dom;
    if (this.dom.$slides.length === 1) return;

    this.swiperMain = new Swiper($sliderMain, {
      //Basic
      autoHeight: true,
      loop: this.loop,
      loopedSlides: this.loopedSlides,
      slidesPerView: 1,
      spaceBetween: this.spaceBetween,

      //Navigation
      navigation: {
        nextEl: '.modal-image-gallery__navigation-next',
        prevEl: '.modal-image-gallery__navigation-prev'
      },

      //Pagination
      pagination: {
        el: '.modal-image-gallery__pagination',
        type: 'fraction',
        renderFraction: (currentClass, totalClass) => {
          return `<span class="${currentClass}"></span> of <span class="${totalClass}"></span> images`;
        }
      },

      //Thumbs
      thumbs: {
        swiper: this.swiperNavigation
      },

      //Callbacks
      on: {
        slideChange: this.slideChangeMain.bind(this)
      }
    });
  } //sliderMain

  slideChangeMain() {
    try {
      if (this.swiperMain && this.swiperModal) {
        const index = this.swiperMain.activeIndex;
        this.swiperModal.slideTo(index, 0);
      }
    } catch (error) {
      return;
    }
  } //slideChangeMain

  sliderController() {
    try {
      this.swiperMain.controller.control = this.swiperNavigation;
    } catch (error) {
      return;
    }
  } //swiperMain

  sliderModal() {
    const { $sliderModal } = this.dom;
    if (this.dom.$slides.length === 1) return;
    this.swiperModal = new Swiper($sliderModal, {
      //Basic
      autoHeight: true,
      loop: this.loop,
      loopedSlides: this.loopedSlides,
      slidesPerView: 1,
      spaceBetween: this.spaceBetween,
      observer: true,
      observeParents: true,

      //Navigation
      navigation: {
        nextEl: '.modal-image-gallery__modal-slider-navigation-right',
        prevEl: '.modal-image-gallery__modal-slider-navigation-left'
      },

      //Callbacks
      on: {
        slideChange: this.slideChangeModal.bind(this)
      }
    });
  } //sliderModal

  slideChangeModal() {
    try {
      if (this.swiperModal && this.swiperMain) {
        const index = this.swiperModal.activeIndex;
        this.swiperMain.slideTo(index);
      }
    } catch (error) {
      return;
    }
  } //slideChangeModal

  setOpenModals() {
    this.dom = {
      ...this.dom,
      $openModal: this.el._$$('.modal-image-gallery__open-modal')
    };
  } //setOpenModals

  setSimpleBars() {
    try {
      Array.prototype.forEach.call(
        document.querySelectorAll('.modal-image-gallery__modal-slide-content'),
        el => new SimpleBar(el, { autoHide: false })
      );
    } catch (error) {
      return;
    }
  } //setSimpleBars
}

export default Module;
